module.exports = __webpack_public_path__ + "assets/207478df1100e602d0a8b925bdba598d.mp3";